import { 
    CREATE_DECK, CREATE_DECK_FAILED, EDIT_DECK, EDIT_DECK_FAILED, 
    GET_DECKS, GET_DECKS_FAILED, GET_PUBLIC_DECKS, GET_PUBLIC_DECKS_FAILED, 
    COPY_DECKS, COPY_DECKS_FAILED, SHARE_USERS_FAILED, EMAIL_RESULTS_FAILED, 
    SHARE_DECKS, SHARE_DECKS_FAILED, EMAIL_RESULTS, REMOVE_QUESTION_FROM_DECK,
    REMOVE_QUESTION_FROM_DECK_FAILED, GET_FLASH_CARDS, GET_FLASH_CARDS_FAILED, 
    GET_PRE_MADE, GET_PRE_MADE_FAILED, GET_QUIZZES_DATA, GET_QUIZ_DATA, 
    GET_LONG_QUIZZES_DATA, GET_PROGRAM_QUIZZES_DATA,
    SAVE_TEST_DATA,
    GET_QUIZZES_RESULTS_DATA,
    GET_QUIZZES_RESULTS_LIST_DATA,
    GET_QUIZZES_RESULTS_LIST_ALL_DATA
} from "../actions"; 
import { setLocalStorage } from "../common";

const INITIAL_STATE = {
    deckList: [],
    flashCards: [],
    publicDecks: [],
    newDeckInfo: [],
    quizListAll: [],
    quizList: [],
    quizResult: [],
    copyDeckInfo: {},
    error: "",
    notes: {},
    serverMsg: {},
    premade: [],
    quizzes: null,
    quiz: null,
    test: null,
    longquizzes: null,
    programquizzes: null,
    cme_tests: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_PRE_MADE: 
            return { ...state, premade: action.payload, error: '' };
        case GET_DECKS:
            const dt = Date.now()
            localStorage.setItem(`sasp_deck_DT`, dt);
            return { ...state, deckList: action.payload, error: '' };
        case EDIT_DECK:
            return { ...state, error: '' };
        case SHARE_DECKS:
            return { ...state, error: '' };
        case GET_QUIZZES_RESULTS_LIST_ALL_DATA:
            return { ...state, quizListAll: action.payload, error: '' };
        case GET_QUIZZES_RESULTS_LIST_DATA: 
            return { ...state, quizList: action.payload, error: '' };
        case GET_QUIZZES_RESULTS_DATA:
            return { ...state, quizResult: action.payload, error: '' };
        case CREATE_DECK:
            return {...state, newDeckInfo: action.payload, error: ''};
        case GET_PUBLIC_DECKS:
            return { ...state, publicDecks: action.payload, error: '' };
        case GET_PUBLIC_DECKS_FAILED:
            return { ...state, error: action.payload, error: '' };
        case COPY_DECKS:
            return { ...state, copyDeckInfo: action.payload, error: '' };
        case EMAIL_RESULTS:
            return { ...state, notes: action.payload, error: '' };
        case REMOVE_QUESTION_FROM_DECK:
            return { ...state, serverMsg: action.payload, error: '' };
        case GET_FLASH_CARDS:
            return { ...state, flashCards: action.payload, error: '' }
        case GET_QUIZZES_DATA: {
            return { ...state, quizzes: action.payload, error: '' }
        }
        case GET_LONG_QUIZZES_DATA: {
            return { ...state, longquizzes: action.payload, error: '' }
        }
        case GET_PROGRAM_QUIZZES_DATA: {
            return { ...state, programquizzes: action.payload, error: '' }
        }
        case GET_QUIZ_DATA:
        case SAVE_TEST_DATA: {
            return { ...state, quiz: action.payload, error: '' }
        }
        
        case GET_PRE_MADE_FAILED:
        case REMOVE_QUESTION_FROM_DECK_FAILED:
        case GET_FLASH_CARDS_FAILED:
        case CREATE_DECK_FAILED:
        case GET_DECKS_FAILED:
        case COPY_DECKS_FAILED:
        case EDIT_DECK_FAILED:
        case GET_PUBLIC_DECKS_FAILED:
        case SHARE_USERS_FAILED:
        case SHARE_DECKS_FAILED:
        case EMAIL_RESULTS_FAILED:
            return { ...state, error: action.payload };
        default:
            return state;
    }
};

//TODO think about whether to fire getdecks after edit/create deck again.
//I think yes...
